import Modal from "./Modal";

function ConfirmModal(props) {
  const { isOpen, onOk, onCancel, message } = props;

  if (!isOpen) {
    return null;
  }

  return (
    <Modal>
      <p className="mb-12 font-bold text-center">{message}</p>
      <div className="flex justify-center gap-4">
        <button
          className="bg-dark-blue text-white px-4 py-1 rounded-lg"
          onClick={onOk}
        >
          تأكيد
        </button>
        <button
          className="px-4 py-1 rounded-lg border border-light-gray"
          onClick={onCancel}
        >
          إلغاء
        </button>
      </div>
    </Modal>
  );
}

export default ConfirmModal;
